import { Navigate } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useMe } from "@/context/MeContext";
import { AdminOrders } from "@/components/admin/AdminOrders";
import { AdminOffers, AdminPartners } from "@/components/admin/AdminCatalog";
import { AdminCustomers, AdminDeclarations, AdminEmails, AdminReport, AdminSms, AdminUsers } from "@/components/admin/AdminPeople";
import { AdminSettings } from "@/components/admin/AdminSettings";
import { AdminWholesale } from "@/components/admin/AdminWholesale";
import { AdminBlog } from "@/components/admin/AdminBlog";

const TABS = [
  ["bonifici", "Bonifici", <AdminOrders mode="bonifici" />],
  ["fatelo", "Ordini Fatelo voi", <AdminOrders mode="fatelo_voi" />],
  ["market", "Ordini Marketplace", <AdminOrders mode="marketplace" />],
  ["status", "Acquisti status", <AdminOrders mode="status" />],
  ["declarations", "Acquisti dichiarati", <AdminDeclarations />],
  ["partners", "Partner", <AdminPartners />],
  ["offers", "Offerte", <AdminOffers />],
  ["wholesale", "Listino ingrosso", <AdminWholesale />],
  ["blog", "Blog", <AdminBlog />],
  ["customers", "Clienti e status", <AdminCustomers />],
  ["report", "Report vendite", <AdminReport />],
  ["users", "Utenti e ruoli", <AdminUsers />],
  ["sms", "SMS", <AdminSms />],
  ["emails", "Email", <AdminEmails />],
  ["settings", "Impostazioni", <AdminSettings />],
];

export default function Admin() {
  const { me } = useMe();
  if (!me) return <p className="py-24 text-center text-slate-500">Caricamento…</p>;
  if (me.role !== "admin") return <Navigate to="/" replace />;
  return (
    <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6" data-testid="admin-page">
      <p className="font-club text-xs text-amber-400">PANNELLO ADMIN · MANAGEBNB SRLS</p>
      <h1 className="mt-2 font-display text-4xl font-extrabold text-white">Controllo del club</h1>
      <Tabs defaultValue="bonifici" className="mt-8">
        <TabsList className="flex h-auto flex-wrap justify-start bg-[#12141C]">
          {TABS.map(([v, l]) => <TabsTrigger key={v} value={v} data-testid={`admin-tab-${v}`}>{l}</TabsTrigger>)}
        </TabsList>
        {TABS.map(([v, , el]) => <TabsContent key={v} value={v} className="mt-6">{el}</TabsContent>)}
      </Tabs>
    </div>
  );
}
